import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import XlsxPopulate from "xlsx-populate";
import { saveAs } from "file-saver";

// reactstrap components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Row, Col, Input } from "reactstrap";

// helpers
import { formateDateandTime } from "helpers/formats";

// services
import { api_POST } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

//Context
import { useAuth } from "../../../context/auth.js";

export default function RelatorioVeiculos({ handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, setValue, clearErrors } = useForm({
    mode: "onBlur",
  });

  const [relatorio, set_relatorio] = useState(null);

  const [optionsTipoCadastro] = useState([
    { value: "RCC", label: "RCC" },
    { value: "RGG", label: "RGG" },
  ]);

  const [tipoCadastro, setTipoCadastro] = useState("");
  const [status, setStatus] = useState("");
  const [transportadorNome, setTransportadorNome] = useState("");
  const [transportadorCPFCNPJ, setTransportadorCPFCNPJ] = useState("");
  const [transportadorCodigoCadastro, setTransportadorCodigoCadastro] = useState("");

  const [optionsStatus] = useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" },
  ]);

  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  const handleTipoCadastro = (value) => {
    setTipoCadastro(value);
    setValue("tipoCadastro", value, true);
    clearErrors("tipoCadastro");
  };

  const handleStatus = (value) => {
    setStatus(value);
    setValue("status", value, true);
    clearErrors("status");
  };

  const buildFiltro = () => ({
    status,
    tipoCadastro,
    transportadorNome,
    transportadorCPFCNPJ,
    transportadorCodigoCadastro,
  });

  const fetchRelatorioVeiculos = async (filtro) => {
    try {
      setLoading(true);
      const { data } = await api_POST("relatorio/RelatorioVeiculos", filtro);
      return data;
    } catch (err) {
      showMessage("Aviso", err.message, "error", null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // Gerar PDF 
  const onSubmit = async () => {
    set_relatorio(null);

    const resultado = await fetchRelatorioVeiculos(buildFiltro());

    if (resultado) {
      set_relatorio(resultado);
    } else {
      set_relatorio(null);
    }
  };

  // Gerar CSV
  const handleCsv = async () => {
    set_relatorio(null);

    const resultado = await fetchRelatorioVeiculos(buildFiltro());

    if (resultado) {
      const cabecalho = [
        "Razão Social",
        "Nome Fantasia",
        "CNPJ/CPF",
        "Código Cadastro",
        "Status Transportador",
        "Validade Transportador",
        "Tipo Cadastro",
        "Responsável",
        "E-mail",
        "Telefone",
        "Endereço",
        "Placa",
        "Tipo Veículo",
        "Status Veículo",
        "Validade Vistoria",
        "Modalidades",
      ];

      const escapeCSV = (str) => {
        if (str === null || str === undefined) return '""';
        const escaped = String(str).replace(/"/g, '""');
        return `"${escaped}"`;
      };

      const linhasCSV = [cabecalho.map(escapeCSV).join(";")];

      (resultado.transportadores || []).forEach((t) => {
        (t.veiculos || []).forEach((v) => {
          const row = [
            t.razaoSocial,
            t.nomeFantasia,
            t.cnpj,
            t.codigoCadastro,
            t.status,
            t.dataValidade,
            t.tipoCadastro,
            t.nomeResponsavel,
            t.email,
            t.telefone,
            t.endereco,
            v.placa,
            v.tipoVeiculo,
            v.status,
            v.dataValidadeVistoria,
            (v.modalidades || []).join(", "),
          ];
          linhasCSV.push(row.map(escapeCSV).join(";"));
        });
      });

      const csvContent = "\uFEFF" + linhasCSV.join("\r\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const dia = new Date();
      
      const day = String(dia.getDate()).padStart(2, '0');
      const month = String(dia.getMonth() + 1).padStart(2, '0');
      const year = dia.getFullYear();

      saveAs(
        blob,
        `RelatorioVeiculos_${day}${month}${year}.csv`
      );
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="6" className="noPrint">
            <Button color="Primary" onClick={handleReturn}>
              <i className="fas fa-chevron-left"></i> Voltar
            </Button>
          </Col>
          {relatorio != null && (
            <Col md="6" className="text-right noPrint">
              <Button color="danger" onClick={handlePrint}>
                <i className="fas fa-print"></i>
              </Button>
            </Col>
          )}
        </Row>

        {relatorio == null && (
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="9">
                      <h4 className="mb-0 mt-0">Relatório de Veículos</h4>
                      <label className="rel-subtitle">
                        Veículos agrupados por Transportador.
                      </label>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="noPrint">
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Tipo de Cadastro:
                          </label>
                          <Select
                            options={optionsTipoCadastro}
                            name="tipoCadastro"
                            onChange={(e) => handleTipoCadastro(e.value)}
                            value={
                              tipoCadastro !== "" &&
                              optionsTipoCadastro.find(
                                (obj) => obj.value === tipoCadastro
                              )
                            }
                            placeholder="TODOS"
                            ref={(e) =>
                              register(
                                { name: "tipoCadastro" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Nome Transportador:
                          </label>
                          <Input
                            type="text"
                            maxLength="100"
                            name="transportadorNome"
                            innerRef={register({ required: false })}
                            defaultValue=""
                            onChange={(e) =>
                              setTransportadorNome(e.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            CPF/CNPJ:
                          </label>
                          <Input
                            type="text"
                            maxLength="20"
                            name="transportadorCPFCNPJ"
                            innerRef={register({ required: false })}
                            defaultValue=""
                            onChange={(e) =>
                              setTransportadorCPFCNPJ(e.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Código de Cadastro:
                          </label>
                          <Input
                            type="text"
                            maxLength="50"
                            name="codigoCadastro"
                            innerRef={register({ required: false })}
                            defaultValue=""
                            onChange={(e) =>
                              setTransportadorCodigoCadastro(e.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Status da Placa:
                          </label>
                          <Select
                            options={optionsStatus}
                            name="status"
                            onChange={(e) => handleStatus(e.value)}
                            value={
                              status !== "" &&
                              optionsStatus.find((obj) => obj.value === status)
                            }
                            placeholder="TODOS"
                            ref={(e) =>
                              register(
                                { name: "status" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="info"
                          className="btn-mobile"
                          type="submit"
                        >
                          Gerar Relatório
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="danger"
                          className="btn-mobile"
                          type="button"
                          onClick={handleCsv}
                        >
                          Gerar CSV
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* PDF */}
        {relatorio != null && (
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <ComponentToPrint relatorio={relatorio} ref={componentRef} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;

  return (
    <div ref={ref}>
      {/* Cabeçalho do relatório */}
      <div className="row">
        <div className="col-9">
          <h4 className="mb-0 mt-0">Relatório de Veículos</h4>
          <label>Veículos agrupados por Transportador.</label>
        </div>
        <div className="col-3 text-right">
          <label>Gerado em {formateDateandTime(new Date())}</label>
        </div>
      </div>

      {relatorio != null && (
        <>
          <h5>
            <strong>
              Total de Transportadores: {relatorio.totalTransportadores} &nbsp;|&nbsp;
              Total de Veículos: {relatorio.totalVeiculos}
            </strong>
          </h5>

          {(relatorio.transportadores || []).map((t, tKey) => (
            <div className="rel-group" key={tKey} style={{ marginBottom: "24px" }}>

              {/* ─── Dados do Transportador ─────────────────────────────── */}
              <div
                className="row rel-item"
                style={{
                  background: "#f5f5f5",
                  borderLeft: "4px solid #005a8d",
                  paddingLeft: "8px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  marginBottom: "6px",
                }}
              >
                <div className="col-12 mb-1">
                  <strong style={{ fontSize: "1rem" }}>
                    {tKey + 1}. {t.razaoSocial || t.nomeFantasia}
                  </strong>
                </div>
                {!!t.nomeFantasia && t.nomeFantasia !== t.razaoSocial && (
                  <div className="col-6">
                    <span><b>Nome Fantasia: </b></span>
                    <span>{t.nomeFantasia}</span>
                  </div>
                )}
                <div className="col-6">
                  <span><b>CNPJ/CPF: </b></span>
                  <span>{t.cnpj}</span>
                </div>
                <div className="col-6">
                  <span><b>Código de Cadastro: </b></span>
                  <span>{t.codigoCadastro}</span>
                </div>
                <div className="col-6">
                  <span><b>Status: </b></span>
                  <span>{t.status}</span>
                </div>
                {!!t.tipoCadastro && (
                  <div className="col-6">
                    <span><b>Tipo de Cadastro: </b></span>
                    <span>{t.tipoCadastro}</span>
                  </div>
                )}
                {!!t.dataValidade && (
                  <div className="col-6">
                    <span><b>Validade: </b></span>
                    <span>{t.dataValidade}</span>
                  </div>
                )}
                {!!t.nomeResponsavel && (
                  <div className="col-6">
                    <span><b>Responsável: </b></span>
                    <span>{t.nomeResponsavel}</span>
                  </div>
                )}
                {!!t.telefone && (
                  <div className="col-6">
                    <span><b>Telefone: </b></span>
                    <span>{t.telefone}</span>
                  </div>
                )}
                {!!t.email && (
                  <div className="col-6">
                    <span><b>E-mail: </b></span>
                    <span>{t.email}</span>
                  </div>
                )}
                {!!t.endereco && (
                  <div className="col-12">
                    <span><b>Endereço: </b></span>
                    <span>{t.endereco}</span>
                  </div>
                )}
              </div>

              {/* ─── Lista de Veículos do Transportador ─────────────────── */}
              <div className="table-responsive" style={{ marginLeft: "8px" }}>
                <table className="table table-sm table-bordered" style={{ fontSize: "0.82rem" }}>
                  <thead style={{ background: "#d9e8f0" }}>
                    <tr>
                      <th>Placa</th>
                      <th>Tipo</th>
                      <th>Status</th>
                      <th>Val. Vistoria</th>
                      <th>Modalidades</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(t.veiculos || []).map((v, vKey) => (
                      <tr key={vKey}>
                        <td><strong>{v.placa}</strong></td>
                        <td>{v.tipoVeiculo}</td>
                        <td>{v.status}</td>
                        <td>{v.dataValidadeVistoria}</td>
                        <td>{(v.modalidades || []).join(", ")}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ fontSize: "0.8rem", color: "#555", marginLeft: "8px" }}>
                Total de veículos: <strong>{(t.veiculos || []).length}</strong>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
});

export const ComponentToExcel = React.forwardRef((props, ref) => {
  const lista = props.lista;

  async function saveAsExcel() {
    const header = [
      "Razão Social",
      "Nome Fantasia",
      "CNPJ/CPF",
      "Código Cadastro",
      "Status Transportador",
      "Validade Transportador",
      "Tipo Cadastro",
      "Responsável",
      "E-mail",
      "Telefone",
      "Endereço",
      "Placa",
      "Tipo Veículo",
      "Status Veículo",
      "Validade Vistoria",
      "Modalidades",
    ];

    const rows = lista.map((l) => [
      l.razaoSocial,
      l.nomeFantasia,
      l.cnpj,
      l.codigoCadastro,
      l.transportadorStatus,
      l.dataValidade,
      l.tipoCadastro,
      l.nomeResponsavel,
      l.email,
      l.telefone,
      l.endereco,
      l.placa,
      l.tipoVeiculo,
      l.veiculoStatus,
      l.dataValidadeVistoria,
      l.modalidades,
    ]);

    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const dia = new Date();
      const sheet1 = workbook.sheet(0).name("Veículos");
      sheet1.cell("A1").value([header, ...rows]);
      const endColumn = String.fromCharCode(64 + header.length);
      sheet1.row(1).style("bold", true);
      sheet1.range(`A1:${endColumn}1`);
      return workbook.outputAsync().then((res) => {
        saveAs(
          res,
          `RelatorioVeiculos_${dia.getDate()}${dia.getMonth() + 1}${dia.getFullYear()}.xlsx`
        );
      });
    });
  }

  return (
    <>
      <Col md="12" className="text-right noPrint">
        <Button className="btn btn-info" onClick={saveAsExcel}>
          Exportar como XLS
        </Button>
      </Col>
      <Card className="card-stats">
        <CardBody>
          <div className="table-responsive">
            <table id="Veiculos_Excel" className="table table-sm">
              <thead>
                <tr>
                  <th>Razão Social</th>
                  <th>Nome Fantasia</th>
                  <th>CNPJ/CPF</th>
                  <th>Código</th>
                  <th>Status Transp.</th>
                  <th>Val. Transp.</th>
                  <th>Tipo Cadastro</th>
                  <th>Responsável</th>
                  <th>E-mail</th>
                  <th>Telefone</th>
                  <th>Endereço</th>
                  <th>Placa</th>
                  <th>Tipo Veículo</th>
                  <th>Status Veíc.</th>
                  <th>Val. Vistoria</th>
                  <th>Modalidades</th>
                </tr>
              </thead>
              <tbody>
                {lista.map((item, index) => (
                  <tr key={index}>
                    <td>{item.razaoSocial}</td>
                    <td>{item.nomeFantasia}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.codigoCadastro}</td>
                    <td>{item.transportadorStatus}</td>
                    <td>{item.dataValidade}</td>
                    <td>{item.tipoCadastro}</td>
                    <td>{item.nomeResponsavel}</td>
                    <td>{item.email}</td>
                    <td>{item.telefone}</td>
                    <td>{item.endereco}</td>
                    <td><strong>{item.placa}</strong></td>
                    <td>{item.tipoVeiculo}</td>
                    <td>{item.veiculoStatus}</td>
                    <td>{item.dataValidadeVistoria}</td>
                    <td>{item.modalidades}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </>
  );
});
